_ = require 'underscore'

class DisplayEntityMixin
  # This does preprocessing on the entities, specifically member entities, to
  # include any nonPublic data we may have available
  getDisplay: ->
    display = @get('display')
    if !display
      return null
    entities = _.mapObject _.clone(display.entities), (e) =>
      entity = _.clone(e)
      if entity.type == 'member'
        memberModel = @modelCache.get('Member', entity.id)
        entity.text = memberModel.get('fullName') || entity.text

      return entity
    return _.extend(display, { entities })

module.exports = DisplayEntityMixin
